export const LOADING = 'LOADING';
export const LOADED_PACHI_DATA = 'LOADED_PACHI_DATA';
export const LOADED_SLOT_DATA = 'LOADED_SLOT_DATA';
export const ERROR = 'ERROR';

export const UPDATE_ERROR = 'UPDATE_ERROR';

export const SCROLL = 'SCROLL';
export const LOADED_NEXT_PACHI_DATA = 'LOADED_NEXT_PACHI_DATA';
export const LOADED_NEXT_SLOT_DATA = 'LOADED_NEXT_SLOT_DATA';
export const CLICK_UPDATE = 'CLICK_UPDATE'; //リセットボタン

export const CLICK_SORT = 'CLICK_SORT'; //ソート
export const CLICK_SORT_SUMMARY = 'CLICK_SORT_SUMMARY'; //ソート(スマホ)
export const CHANGE_PS_RATE = 'CHANGE_PS_RATE'; // PS&レート変更時
export const LOADED_KISHU_LIST = 'LOADED_KISHU_LIST'; // パチンコorスロット機種リスト取得
